import { Paper, styled } from "@mui/material";

export const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  border: `1px solid ${theme.palette.divider}`
}));
